export default __webpack_public_path__ + "static/media/dark-unknown.c6e42a0b.png";